/* eslint-disable max-lines-per-function */
/* eslint-disable max-len */
(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('WidgetAcumuladoChuvaPeriodoCtrl', WidgetAcumuladoChuvaPeriodoController);

  WidgetAcumuladoChuvaPeriodoController.$inject = [
    '$scope',
    'DadosMeteorologicosService',
    'googleChartApiPromise',
    'Dashboard',
    'PluviometrosService'
  ];

  // eslint-disable-next-line max-params
  function WidgetAcumuladoChuvaPeriodoController($scope, DadosMeteorologicosService, googleChartApiPromise, Dashboard, PluviometrosService) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.error = false;
    vm.empty = false;
    vm.loading = true;
    vm.chart = {
      type: 'ComboChart'
    };

    //////////////////////////////////////////
    // Bindable methods
    vm.validChart = validChart;

    //////////////////////////////////////////
    // Function declarations

    function validChart() {
      const { dataInicial, dataFinal, pluviometro, propriedade } = $scope.widget.dataModelOptions;
      return (dataInicial && dataFinal && pluviometro && propriedade);
    }

    function renderChart() {
      vm.empty = false;
      vm.error = false;
      vm.chart = {
        type: 'ComboChart'
      };
      vm.loading = true;
      const propriedade = $scope.widget.dataModelOptions.propriedade || $scope.$root.currentPropriedade;
      const pluviometro = $scope.widget.dataModelOptions.pluviometro;

      const request = DadosMeteorologicosService.list({
        data_inicial: $scope.widget.dataModelOptions.dataInicial,
        data_final: $scope.widget.dataModelOptions.dataFinal,
        propriedade: propriedade.id,
        cd_pluviometro: pluviometro.cd_pluviometro,
        cd_produtor: pluviometro.cd_produtor
      });

      return request.then(({ data }) => prepareChart(data));
    }

    function getDateIntervals() {
      const { daysInterval, dataInicial, dataFinal } = $scope.widget.dataModelOptions;
      const daySeparators = [];

      for (let dataInicialToSet = moment(dataInicial);
        moment(dataFinal).isAfter(dataInicialToSet);
        dataInicialToSet.add(daysInterval, 'day')
      ) {
        const startOfMonth = moment(dataInicialToSet).clone()
          .startOf('month');
        const endOfMonth = moment(dataInicialToSet).clone()
          .endOf('month');

        // Primeira data inicial = inicio do mês
        if (dataInicialToSet.diff(startOfMonth, 'days') < daysInterval) {
          dataInicialToSet = startOfMonth;

          // Ignora o fim do mês
        } else if (endOfMonth.isSame(dataInicialToSet, 'day')) {
          continue;
        }

        let dataFinalToSet = dataInicialToSet.clone().add(daysInterval, 'days');

        // Ultima data final = final do mês
        if (endOfMonth.diff(dataInicialToSet, 'days') <= daysInterval ||
          !endOfMonth.isSame(dataFinalToSet, 'month')) {
          dataFinalToSet = endOfMonth;
        }

        const date = {
          dataInicial: dataInicialToSet.toDate(),
          dataFinal: dataFinalToSet.toDate()
        };

        daySeparators.push(date);
      }
      return daySeparators;
    }

    function prepareChart(result) {
      if (result.length) {
        let chartArray = [
          ['Data', 'Milímetros', 'Média']
        ];

        const daysIntervals = getDateIntervals();
        const reduced = result.reduce((total, data) => {
          const dayInterval = daysIntervals.find((inteval) => {
            const dataInicial = moment(inteval.dataInicial).subtract(1, 'day');
            return moment(data.data).isBetween(dataInicial, inteval.dataFinal);
          });

          if (!dayInterval) {
            return total;
          }

          const index = `${moment(dayInterval.dataInicial).format('DD/MM/YY')} - ${moment(dayInterval.dataFinal).format('DD/MM/YY')}`;

          if (_.isUndefined(total[index])) {
            total[index] = data.chuva;
          } else {
            total[index] += data.chuva;
          }

          return total;
        }, {});

        const media = _.mean(Object.values(reduced));

        const arrayToConcat = Object.entries(reduced).map((element) => {
          element[2]= media;
          return element;
        });

        chartArray = chartArray.concat(arrayToConcat);
        createChart(chartArray);
      } else {
        vm.loading = false;
        vm.empty = true;
      }
    }


    function createChart(array) {
      return googleChartApiPromise.then(() => {
        vm.chart = chartOptions();
        vm.chart.data = array;
        vm.loading = false;
      });
    }

    function chartOptions() {
      return {
        type: 'ComboChart',
        data: {
          cols: [],
          rows: []
        },
        options: {
          legend: { position: 'none' },
          vAxis: {
            title: 'Milímetros'
          },
          chartArea: {
            width: '70%',
            height: '70%',
            left: 80
          },
          series: {
            0: {
              type: 'bars'
            },
            1: {
              type: 'line'
            }
          }
        }
      };
    }

    function calcChartWidth() {
      return Dashboard.calcChartWidth($scope.widget.size.width);
    }


    //  set settings values

    async function getPluviometros() {
      try {
        const { propriedade } = $scope.widget.dataModelOptions;
        if (propriedade) {
          const { data: pluviometros } = await PluviometrosService.list({ propriedade: propriedade.id });

          return pluviometros;
        }

        return [];
      } catch (error) {
        vm.error = true;
        console.error('Erro ao buscar pluviômetros', error);
        return error;
      }
    }

    async function setWidgetData() {
      const propriedades = $scope.$root.propriedades.map((propriedade) => {
        const glebas = propriedade.glebas.map((gleba) => (
          {
            id: gleba.id,
            descricao: gleba.descricao
          }
        ));

        return {
          id: propriedade.id,
          descricao: propriedade.descricao,
          glebas
        };
      });

      const pluviometros = await getPluviometros();

      $scope.widget.data = {
        propriedades,
        pluviometros
      };
    }

    function setSettingInitialValues() {
      let { dataFinal, dataInicial, daysInterval } = $scope.widget.dataModelOptions;

      if (_.isNull(dataFinal) && _.isNull(dataInicial)) {
        dataInicial = moment()
          .startOf('year')
          .toDate();

        dataFinal = moment()
          .endOf('year')
          .toDate();
      } else {
        dataInicial = moment(dataInicial).toDate();
        dataFinal = moment(dataFinal).toDate();
      }


      if (_.isNull(daysInterval)) {
        daysInterval = 15;
      }

      $scope.widget.dataModelOptions = {
        ...$scope.widget.dataModelOptions,
        dataInicial,
        dataFinal,
        daysInterval
      };
    }

    //////////////////////////////////////////
    // Controller logic
    $scope.$root.initialize.then(() => {
      setWidgetData();
      setSettingInitialValues();

      $scope.$watch('widget.dataModelOptions', () => {
        if (vm.validChart()) {
          const render = renderChart();
          render.catch((error) => {
            vm.error = true;
            console.error('Erro ao renderizar gráfico', error);
          });
        }
      }, true);
      $scope.$watch('widget.size.width', () => {
        if ((vm.chart || {}).options) {
          vm.chart.options.width = `${calcChartWidth()}px`;
        }
      });
    })
      .catch($scope.$root.errorRootInitialize);
  }
}());
